import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { filter } from 'rxjs';

import { CmsService } from '@spartacus/core';

import { ILink, SdCopyrightComponent, ThemesEnum, BrandsEnum } from '@seb/web-design-system/core';

import { HobStateService } from '@seb/web-common/core/services';
import { HobMapper } from '@seb/web-common/core/mappers';

import { CustomCmsLinkComponent, LegalFooterModuleInterface } from '../../../models';
import { AbstractModuleComponent } from '../abstract-module.component';
import { LinkMapper } from '../../../mappers';

@Component({
  selector: 'wc-legal-footer-module',
  templateUrl: './legal-footer-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdCopyrightComponent]
})
export class LegalFooterModuleComponent extends AbstractModuleComponent<LegalFooterModuleInterface> implements OnInit {
  themesConfig: ThemesEnum.light | ThemesEnum.dark;
  changeCountryName: string;
  changeCountryUrl: string;
  links: ILink[];
  isHob: boolean;
  activeBrand: BrandsEnum;

  constructor(
    private cmsService: CmsService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly hobStateService: HobStateService,
    private readonly hobMapper: HobMapper
  ) {
    super();
  }

  override mandatoryFunction = (cmp: LegalFooterModuleInterface): boolean => {
    return !!cmp.countrySelectorLink && !!cmp.countrySelectorName;
  };

  override mandatoryComponentFunction = (cmp: CustomCmsLinkComponent): boolean => {
    return (!!cmp.url || !!cmp.urlLocalized) && !!cmp.linkName;
  };

  ngOnInit(): void {
    this.initPageTheme();

    this.subscriptions.add(
      this.hobStateService.hobState$.subscribe(({ isHob, liveBrand, siteBrand }) => {
        this.activeBrand = liveBrand || siteBrand;
        this.isHob = isHob;
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.module$.subscribe((module: LegalFooterModuleInterface) => {
        this.changeCountryName = module.countrySelectorName;
        this.changeCountryUrl = module.countrySelectorLink;
        this.links = module.componentsObjects.map((cmp) => LinkMapper.cmsLinkToILink(cmp));

        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }

  private initPageTheme(): void {
    this.subscriptions.add(
      this.cmsService.getCurrentPage().pipe(
        filter((page) => !!page)
      ).subscribe((page) => {
        this.themesConfig = page['headerTheme'] ? ThemesEnum[page['headerTheme']?.toLowerCase()] : ThemesEnum.light;
      })
    );
  }
}
